export const environment = {
  production: false,
  appInsights: {
    instrumentationKey: '5e8b4e20-471e-401a-a2d2-746462082409'
  },
  authAPIURL: 'https://dev-portal-xbs.transfast.net',
  backOfficeApiURL: 'https://dev-xbcnode1:8001',
  catalogApiURL: 'https://dev-xbcnode1:8002'
};
